"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1509250/img/communal_dinner_warm_light.png)]" aria-hidden="true">
        <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm" />
      </div>

      {}
      <div className={`
          relative z-10 max-w-4xl mx-auto px-6 text-center
          transition-all duration-[200ms] ease-out
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
        `}>
        {}
        <div className="inline-block bg-dark-background/80 backdrop-blur-md rounded-lg px-8 py-10 md:px-12 md:py-14">
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-dark-foreground mb-4">
            Yes Chef Jess
          </h1>
          <p className="text-lg md:text-xl text-dark-foreground/90 mb-8 max-w-2xl mx-auto">
            Experience the joy of cooking and community through intimate supper clubs and hands-on cooking classes in Los Angeles
          </p>

          <Button asChild className="
              bg-primary text-foreground-primary px-8 py-4 text-base font-semibold rounded-md
              hover:bg-primary-hover hover:shadow-medium hover:scale-105
              active:bg-primary-active active:scale-100
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
              transition-all duration-[120ms] ease-[var(--ease-spring)]
            ">
            <Link to="#about-us">Discover Our Story</Link>
          </Button>
        </div>
      </div>
    </section>;
}